"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\t", "\n"], ["\n\t", "\n"])), function (props) { return props.theme.spinner.container; });
var Button = styled_components_1.default.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tvertical-align: top;\n\t", "\n"], ["\n\tvertical-align: top;\n\t", "\n"])), function (props) { return props.theme.spinner.button; });
var Counter = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tvertical-align: top;\n\t", "\n"], ["\n\tvertical-align: top;\n\t", "\n"])), function (props) { return props.theme.spinner.counter; });
var Spinner = /** @class */ (function (_super) {
    __extends(Spinner, _super);
    function Spinner() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.clamp = function (value) {
            var min = _this.props.min || Spinner.defaultProps.min;
            var max = _this.props.max || Spinner.defaultProps.max;
            return Math.min(Math.max(value, min), max);
        };
        _this.onChange = function (value) {
            value = _this.clamp(value);
            var change = value - _this.props.value;
            if (change !== 0) {
                if (change < 0 && _this.props.onDecrement) {
                    _this.props.onDecrement(-change);
                }
                else if (change > 0 && _this.props.onIncrement) {
                    _this.props.onIncrement(change);
                }
                if (_this.props.onChange) {
                    _this.props.onChange(value);
                }
            }
        };
        _this.onDecrement = function () {
            _this.onChange(_this.props.value - (_this.props.step || Spinner.defaultProps.step));
        };
        _this.onIncrement = function () {
            _this.onChange(_this.props.value + (_this.props.step || Spinner.defaultProps.step));
        };
        return _this;
    }
    Spinner.prototype.render = function () {
        var current = this.clamp(this.props.value);
        return (react_1.default.createElement(Container, { className: this.props.className },
            react_1.default.createElement(Button, { onClick: this.onDecrement, "aria-label": "decrement", disabled: current === this.props.min, "data-automationid": "spinner_decrement" }, this.props.theme.svgs.decrement),
            this.props.showCounter &&
                react_1.default.createElement(Counter, null, this.props.value),
            react_1.default.createElement(Button, { onClick: this.onIncrement, "aria-label": "increment", disabled: current === this.props.max, "data-automationid": "spinner_increment" }, this.props.theme.svgs.increment)));
    };
    Spinner.defaultProps = {
        min: Number.MIN_SAFE_INTEGER,
        max: Number.MAX_SAFE_INTEGER,
        step: 1,
        showCounter: true
    };
    return Spinner;
}(react_1.Component));
exports.default = styled_components_1.withTheme(Spinner);
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Spinner.js.map